import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {DomainResolver} from "../model/domain-resolver";
import {Observable} from "rxjs";
import {XsrfTokenReader} from "../services/xsrf-token-reader.service";

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {

  constructor(private tokenReader: XsrfTokenReader, private domainResolver: DomainResolver) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(this.domainResolver.api)) {
      return next.handle(req);
    }

    const domain = req.url.slice(this.domainResolver.api.length).split('/')[0];
    const token = this.tokenReader.getToken(domain);
    if (req.method === 'GET' || req.method === 'HEAD' || !token) {
      return next.handle(req);
    }

    return next.handle(req.clone({headers: req.headers.set('X-XSRF-TOKEN', token)}));
  }
}
